module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/prev_on-fff7aca0cd37efa14f043846c1922848.gif";